import { render, staticRenderFns } from "./ShopExhibitionList.vue?vue&type=template&id=5a3a6d54&scoped=true&"
import script from "./ShopExhibitionList.vue?vue&type=script&lang=js&"
export * from "./ShopExhibitionList.vue?vue&type=script&lang=js&"
import style0 from "./ShopExhibitionList.vue?vue&type=style&index=0&id=5a3a6d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a6d54",
  null
  
)

export default component.exports